// このファイルは設計書（231 プログラム生成元ドキュメント）の表から生成した。手で直すときは設計書と突き合わせること。
// 03 フロントエンド設計書 4.4 の FE-MSG（BE-13）。「／」は改行に置き換えた。

export const FE_MESSAGES = {
  'FE-MSG-V-001': { text: 'メールアドレスを入力してください' },
  'FE-MSG-V-002': { text: '有効なメールアドレスを入力してください' },
  'FE-MSG-V-003': { text: '失注の理由を記入してください' },
  'FE-MSG-V-004': { text: '選択してください' },
  'FE-MSG-V-005': { text: '稼働時間の上限は下限以上にしてください' },
  'FE-MSG-V-006': { text: '終了日は開始日以降の日付にしてください' },
  'FE-MSG-V-007': { text: '終了日が今日より後の契約は「終了」にできません' },
  'FE-MSG-V-008': { text: 'フィールド名が重複しています' },
  'FE-MSG-V-009': { text: 'フィールド名は英小文字で始まる半角英数字と _（50 文字以内）で入力してください' },
  'FE-MSG-V-010': { text: '選択肢を1つ以上追加してください' },
  'FE-MSG-V-011': { text: 'ロールコードは英小文字で始まる半角英数字と _ で入力してください' },
  'FE-MSG-V-012': { text: '期間は366日以内で指定してください' },
  'FE-MSG-V-013': { text: '期間は92日以内で指定してください' },
  'FE-MSG-V-014': { text: 'タスクは40件までです' },
  'FE-MSG-V-015': { text: '個人の目標では担当者を選択してください' },
  // 273：旧PCRMから落ちていた同意必須を戻す（旧 validateSubmission の文言）
  'FE-MSG-V-016': { text: '個人情報の取り扱いへの同意が必要です' },
  'FE-MSG-C-001': { text: '選択した${count}件の顧客を削除してもよろしいですか？\n\n削除対象:\n${names}' },
  'FE-MSG-C-002': { text: '選択した${count}件の案件を削除してもよろしいですか？\n\n削除対象:\n${names}' },
  'FE-MSG-C-003': { text: '選択した${count}件の取引を削除してもよろしいですか？\n\n削除対象:\n${names}' },
  'FE-MSG-C-004': { text: '選択した${count}件のロールを削除してもよろしいですか？\n\n削除対象:\n${names}' },
  'FE-MSG-C-005': { text: '選択した${count}件のユーザーにSES検証メールを送信しますか？\n\n送信対象:\n${names}' },
  'FE-MSG-C-006': { text: '選択した${count}件の${target_name}を削除してもよろしいですか？\n\n削除対象:\n${names}' },
  'FE-MSG-C-007': { text: '「${name}」を削除してもよろしいですか？' },
  'FE-MSG-C-008': {
    text: 'API キーを再発行すると、今のキーはすぐに使えなくなります。設置先のコードも差し替えが必要です。再発行しますか？',
  },
  'FE-MSG-C-009': { text: '「${name}」を復元しますか？（一緒に削除された関連データも元に戻ります）' },
  'FE-MSG-C-010': { text: '支払い状況を「${to}」に戻しますか？請求日・入金日の値が消えます。' },
  'FE-MSG-S-001': {
    text: '確認用のメールを送信しました。メール内のリンクを開いたあと、もう一度「確認コードを送信」を押してください。',
  },
  'FE-MSG-S-002': { text: '${sent_count}件のSES検証メールを送信しました' },
  'FE-MSG-S-003': { text: '案件を登録しました' },
  'FE-MSG-S-004': { text: '案件を更新しました' },
  'FE-MSG-S-005': { text: '取引を登録しました' },
  'FE-MSG-S-006': { text: '取引を更新しました' },
  'FE-MSG-S-007': { text: '活動を登録しました' },
  'FE-MSG-S-008': { text: '活動を更新しました' },
  'FE-MSG-S-009': { text: '活動を削除しました' },
  'FE-MSG-S-010': { text: '商品を登録しました' },
  'FE-MSG-S-011': { text: '商品を更新しました' },
  'FE-MSG-S-012': { text: '商品を削除しました' },
  'FE-MSG-S-013': { text: 'ユーザーを登録しました' },
  'FE-MSG-S-014': { text: 'フォームを保存しました' },
  'FE-MSG-S-015': { text: '公開中のフォームを変更したため、新しいバージョンとして保存しました' },
  'FE-MSG-S-016': { text: 'API キーを再発行しました' },
  'FE-MSG-S-017': { text: '顧客に紐づけました' },
  'FE-MSG-S-018': { text: '顧客との紐付けを外しました' },
  'FE-MSG-S-019': { text: '活動履歴に記録しました' },
  'FE-MSG-S-020': { text: 'メールを送信しました' },
  'FE-MSG-S-021': { text: '記録を保存しました' },
  'FE-MSG-S-022': { text: 'コンタクトを開始しました' },
  'FE-MSG-S-023': { text: 'コンタクトを削除しました' },
  'FE-MSG-S-024': { text: '「${name}」を復元しました' },
  'FE-MSG-S-025': { text: 'チェックリストを${created_count}件作成しました（作成済み ${skipped_count}件）' },
  'FE-MSG-S-026': { text: '支払い状況を戻しました' },
  'FE-MSG-S-027': { text: 'コピーしました' },
  'FE-MSG-S-028': { text: 'ファイルを作成しました。ダウンロードを開始します' },
  'FE-MSG-S-029': { text: '取込が終わりました（成功 ${success_row_count}件・エラー ${error_row_count}件）' },
  'FE-MSG-S-030': { text: 'ステータスを「${case_status_name}」に変更しました' },
  'FE-MSG-S-031': { text: '回答を削除しました' },
  'FE-MSG-I-001': { text: 'テンプレートがありません' },
  'FE-MSG-I-002': { text: '出力ファイルを作成しています…' },
  'FE-MSG-I-003': { text: '取込を実行しています…' },
  'FE-MSG-I-004': { text: '処理に時間がかかっています。「もう一度確認」を押すと状況を確認できます' },
  'FE-MSG-I-005': { text: 'この画面は PC での利用を想定しています' },
  'FE-MSG-I-006': { text: '実績は案件・取引・活動から自動で集計されます' },
  'FE-MSG-I-007': { text: '入力中の内容は消えていません。確認コードでログインし直すと、続きから保存できます。' },
  'FE-MSG-I-008': {
    text: '他の利用者が更新した最新の内容を読み込みました。入力内容を確かめてから、もう一度保存してください。',
  },
  'FE-MSG-I-009': { text: '成約にしました。続けて取引を登録しますか？' },
  'FE-MSG-I-010': { text: 'API キーは今だけ表示します。控えてから閉じてください。' },
  'FE-MSG-I-011': { text: '削除済みのデータを表示しています' },
  'FE-MSG-I-012': { text: '（削除済み）' },
  'FE-MSG-I-013': { text: '要確認（自動送信対策の判定ができなかった回答です）' },
  'FE-MSG-I-014': { text: '処理中です。しばらくお待ちください。' },
  'FE-MSG-I-015': { text: 'このメールアドレスは検証済みです。「確認コードを送信」を押してください。' },
  'FE-MSG-E-001': { text: 'サーバーからの応答がありません。しばらく待ってから再度お試しください。' },
  'FE-MSG-E-002': { text: '通信できませんでした。ネットワークの状態を確かめてから再度お試しください。' },
  'FE-MSG-E-003': {
    text: 'ページが見つかりません\nお探しのページは移動または削除された可能性があります。URL をお確かめください。',
  },
  'FE-MSG-E-004': { text: 'この画面を表示する権限がありません' },
  'FE-MSG-E-005': { text: '最後の有効な管理者は、無効化・削除・管理者以外へのロール変更ができません' },
  'FE-MSG-E-006': { text: '自分自身は削除できません' },
  'FE-MSG-E-007': { text: 'ファイルの形式が正しくありません。' },
  'FE-MSG-E-008': { text: 'フォームの URL が正しくありません。設置した方にお問い合わせください。' },
} as const;

export type FeMessageId = keyof typeof FE_MESSAGES;
